// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d-flex[data-v-4d48b9d2]{display:flex}.spacer[data-v-4d48b9d2]{width:20px}", ""]);
// Exports
module.exports = exports;
